module.exports = __webpack_public_path__ + "img/ca_get.8d7070c.png";